import { ROLE, type Role } from '../domain/enums';
const KNOWN_ROLES: ReadonlySet<number> = new Set<number>(Object.values(ROLE));
export function isRole(value: number): value is Role {
  return KNOWN_ROLES.has(value);
}
export function narrowRole(value: number): Role {
  return isRole(value) ? value : ROLE.USER;
}
